<template>
  <b-badge class="publish-location-label" pill>{{ text }}</b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue';

export default {
  props: ['value'],
  components: {
    BBadge,
  },
  computed: {
    text() {
      switch (this.value) {
        case 'MARKETING':
          return '行銷趨勢';
        case 'NEWS':
          return '最新消息';
        default:
          return '';
      }
    },
  },
};
</script>

<style scoped lang="scss">
.publish-location-label {
  padding: 0.25rem 0.5rem;
  font-size: 80%;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.87);
  background: #e0e0e0 ;
}
</style>
